import _set from 'lodash/set';

import { MutationTree } from "vuex";
import { MaintenancejobsState } from "./types";
import { Maintenancejob } from "@/models";
import _ from 'lodash';

/**
 * Mutations
 *
 * The only way to actually change state in a Vuex store is by committing a mutation.
 * - Vuex mutations are very similar to events: each mutation has a string type and a handler.
 * - The handler function is where we perform actual state modifications - it receives the state as the first argument:
 * - You cannot directly call a mutation handler.
 * - Think of it more like event registration: "When a mutation with type X is triggered, call this handler."
 * - To invoke a mutation handler, you need to call store.commit with its type e.g. `store.commit('setUser', user)`
 */
export const mutations: MutationTree<MaintenancejobsState> = {

	/**
	 * Set the maintenancejobs list
	 * 
	 * @param {MaintenancejobsState} state
	 * @param {Maintenancejob[]} Maintenancejobs
	 * @returns void
	 */
	setMaintenancejobs(state: MaintenancejobsState, maintenancejobs: Maintenancejob[]): void {
		state.list = maintenancejobs;
	},

	/**
	 * Set current maintenancejob
	 * 
	 * @param {MaintenancejobsState} state
	 * @param {Maintenancejob} Maintenancejob
	 * @returns void
	 */
	setCurrent(state: MaintenancejobsState, maintenancejob: Maintenancejob): void {
		state.current = maintenancejob;
	},

	/**
   * Set current page
   *
   * @param state ReportsState
   * @param currentPage number
   * @returns void
   */
	setCurrentPage(state: MaintenancejobsState, currentPage: number): void {
		state.currentPage = currentPage;
	},

	/**
	 * Set the currently edited/viewed maintenancejob
	 */
	setMaintenancejobDeep(state: MaintenancejobsState, payload: { path: string, data: any }): void {
		state.current = Object.assign(new Maintenancejob, _set(state.current, payload.path, payload.data));
	},

	/**
	 * ++ Unsaved changes
	 * 
	 * @param state MaintenancejobsState
	 * @param element string
	 * @returns void
	 */
	addUnsavedChange(state: MaintenancejobsState, element: string): void {
		state.updates = [...new Set(state.updates.concat([element]))];
	},

	/**
	  * Reset Unsaved changes
	  * 
	  * @param state MaintenancejobsState
	  * @returns void
	  */
	resetUnsavedChanges(state: MaintenancejobsState): void {
		state.updates = [];
	},


	/**
   * Set the search for the Maintenancejobs query.
   *
   * @param state Maintenancejobs
   * @param search Search text
   * @returns void
   */
	setSearch(state: MaintenancejobsState, search?: string): void {
		state.search = search;
	},

	/**
	 * Set the filterclient for the Maintenancejobs query.
	 *
	 * @param state MaintenancejobsState
	 * @param filterclient Filter customer
	 * @returns void
	 */
	setFilterCustomer(state: MaintenancejobsState, customer?: string): void {
		state.filterCustomer = customer;
	},

	setFilterStatus(state: MaintenancejobsState, status?: string): void {
		state.filterStatus = status;
	},
	setFilterInvoiceStatus(state: MaintenancejobsState, status?: string): void {
		state.invoiceFilterStatus = status;
	},

	setFilterContractor(state: MaintenancejobsState, contractor?: string): void {
		state.filterContractor = contractor;
	},

	resetState(state: MaintenancejobsState): void {
		state.current = new Maintenancejob;
		state.list = [];
		state.updates = [];
		state.search = '';
		state.filterCustomer = '';
		state.filterStatus = '';
		state.filterCustomer = '';
		state.invoiceFilterStatus = '';
	},

	rehydrateState(state: MaintenancejobsState): void {
		state.current = new Maintenancejob(state.current);
		state.list = state.list.map((x: any) => new Maintenancejob(x));
	}

}
